import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import WhatsappIcon from "@icons/whatsappIcon.svg";
import styles from "./blogQIMobileCta.module.scss";

export const BlogQIMobileCta = (): ReactElement => {
  const { t } = useTranslation("kunduzcom_common");

  const title = t("redirection_to_packages_section_title").replace(
    /\\n/g,
    "\n",
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.borderTop} />
      <div className={styles.inner}>
        <div className={styles.row1}>
          <div
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          ></div>
          <img
            src="https://media.kunduz.com/cms/media/image.webp"
            alt=""
            loading="lazy"
            className={styles.image}
          />
        </div>
        <p className={styles.description}>
          {t("redirection_to_packages_section_description")}
        </p>
        <div className={styles.row2}>
          <Link
            href="https://api.whatsapp.com/send?phone=908502422294"
            target="_blank"
            className={styles.button1}
          >
            <WhatsappIcon width={20} height={20} />
            {t("redirection_to_packages_section_whatsapp_button_label")}
          </Link>
          <Link href="/tr/paketler/sinifini-sec/" className={styles.button2}>
            {t("redirection_to_packages_section_cta_button_label")}
          </Link>
        </div>
      </div>
    </div>
  );
};
